(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const cartBubbleContainer = document.querySelector(".header--cart");
    if (!cartBubbleContainer) return;
    cartBubbleContainer.style.pointerEvents = "none";
  })
  document.addEventListener('rebuy.loaded', (event) => {
    const cartBubbleContainer = document.querySelector(".header--cart");
    if (!cartBubbleContainer) return;
    cartBubbleContainer.style.pointerEvents = null;
});
  document.addEventListener("rebuy:cart.change", (event) => {
    const cart = event.detail.cart.cart;
    const cartBubbleContainer = document.querySelector(".header--cart");
    if (!cartBubbleContainer || !cart || !cart.item_count) return;
    cartBubbleContainer.dataset.cartCount = cart.item_count;
  });
})();